import defaultTemplates from 'ui-article/axel-publication-content/js/templates';

const templates = {
    ...defaultTemplates,
    // figure viewer
    fvAsideInfo: require('../templates/figure-viewer/fv-asideInfo-client.jade'),
    fvFrame: require('../templates/figure-viewer/fv-frame-client.jade'),
    fvDirectoryItem: require('../templates/figure-viewer/fv-directory-item-client.jade'),
    fvLightboxFigures: require('../templates/figure-viewer/fv-lightbox-client.jade'),
};

export default templates;
